// Section 22 title and menu: Continue, Load save (slots with turn, season and date), earlier
// autosaves (not in ironman), and what the current run allows (Section 3 ironman).
import type { GameState } from '../sim/api';
import type { SaveMeta } from '../persist';
import { memo } from './memo';

export interface SaveRow extends SaveMeta {
  /** Belongs to the run in play. */
  current: boolean;
}

export interface SavesVM {
  slots: SaveRow[];
  /** Ring autosaves, newest first (an ironman run only ever has its newest). */
  autosaves: SaveRow[];
  start: SaveRow | null;
  latest: SaveRow | null;
  /** Named saves are refused in ironman (one rolling save). */
  canSaveSlot: boolean;
  inGame: boolean;
}

export const savesVM = memo(
  (
    index: { autosaves: SaveMeta[]; slots: SaveMeta[] },
    game: GameState | null,
    runId: string,
  ): SavesVM => {
    const row = (m: SaveMeta): SaveRow => ({ ...m, current: game !== null && m.runId === runId });
    const autosaves = index.autosaves.filter((m) => m.kind === 'autosave').map(row);
    const start = index.autosaves.find((m) => m.kind === 'start');
    return {
      slots: index.slots.map(row),
      autosaves,
      start: start === undefined ? null : row(start),
      latest: autosaves[0] ?? (start === undefined ? null : row(start)),
      canSaveSlot: game !== null && !game.options.ironman,
      inGame: game !== null,
    };
  },
);
